var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text -t2",domProps:{"innerHTML":_vm._s(_vm.parsedText)}})}
var staticRenderFns = []

export { render, staticRenderFns }